var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-note',{attrs:{"title":_vm.title,"notes":_vm.notes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }